import { useEffect, useMemo } from "react";
import olVectorSource from "ol/source/Vector";
import { useMap } from "../../../context/map";
import olFeature from "ol/Feature";
import { useBoundaries } from "../../../context/boundary";
import { Style, Text, Fill, Stroke } from "ol/style";
import { Point } from "ol/geom";
import { getCenter } from "ol/extent";
import { Vector } from "../../reactOL/layers";

const LabelLayer = () => {
  const { map } = useMap();
  const { boundaries, showLabels } = useBoundaries();

  const labelSource = useMemo(() => new olVectorSource(), []);

  const view = useMemo(() => map?.getView(), [map]);

  useEffect(() => {
    if (!boundaries || !view) return;

    const features = boundaries.map((boundary) => {
      const center = getCenter(boundary.envelope);

      // Shift geometry ONLY for Stockton-on-Tees (EPSG:3857 units = meters)
      let pointCoord = center;
      if (boundary.name === "Stockton-on-Tees") {
        const dy = -2000;
        pointCoord = [center[0], center[1] - dy];
      }

      const feature = new olFeature({
        id: boundary.id,
        geometry: new Point(pointCoord),
        name: boundary.name,
      });

      feature.setStyle(
        new Style({
          text: new Text({
            text: boundary.name,
            font: "12px sans-serif",
            fill: new Fill({ color: "#000" }),
            stroke: new Stroke({ color: "#fff", width: 3 }),
          }),
        }),
      );

      return feature;
    });

    labelSource.clear(true);
    labelSource.addFeatures(features);
  }, [boundaries, labelSource, view]);
  return (
    <Vector
      name="labels"
      source={labelSource}
      declutter={true}
      visible={showLabels}
      zIndex={100}
    />
  );
};

export default LabelLayer;
